/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { DisplayRef, DisplayRef$inboundSchema } from "./displayref.js";

/**
 * A reference to a sequence.
 */
export type SequenceRef = {
  /**
   * A reading or setting reference that is used to display a value.
   */
  displayRef: DisplayRef;
  /**
   * The key of the sequence.
   */
  key: string;
};

/** @internal */
export const SequenceRef$inboundSchema: z.ZodType<
  SequenceRef,
  z.ZodTypeDef,
  unknown
> = z.object({
  display_ref: DisplayRef$inboundSchema,
  key: types.string(),
}).transform((v) => {
  return remap$(v, {
    "display_ref": "displayRef",
  });
});

export function sequenceRefFromJSON(
  jsonString: string,
): SafeParseResult<SequenceRef, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SequenceRef$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SequenceRef' from JSON`,
  );
}
